module.exports = __webpack_public_path__ + "media/flags/mw-947e87f2.svg";